import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import { warning } from "@universityofmaryland/web-icons-library/indicators";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import { CreateAlertText } from "./elements/text.js";
import { CreateCloseButton } from "./elements/closeButton.js";
import { BREAKPOINTS } from "./globals.js";
const { MEDIUM } = BREAKPOINTS;
const createIcon = (iconMarkup) => new ElementBuilder().withClassName("alert-page-icon").withHTML(iconMarkup).withStyles({
  element: {
    display: "block",
    fill: token.color.gold,
    [`@container (max-width: ${MEDIUM}px)`]: {
      position: "absolute",
      top: "-20px"
    }
  }
}).build();
const createContainer = (props) => {
  const { isShowIcon = true, isThemeDark } = props;
  const textModel = CreateAlertText(props);
  const iconModel = isShowIcon ? createIcon(warning) : null;
  const closeButtonModel = CreateCloseButton({
    isThemeDark: !!isThemeDark,
    targetSelector: ".alert-page-declaration"
  });
  const children = [iconModel, textModel, closeButtonModel].filter(
    Boolean
  );
  return new ElementBuilder().withClassName("alert-page-container").withChildren(...children).withStyles({
    element: {
      color: theme.foreground(isThemeDark),
      display: "flex",
      position: "relative",
      padding: token.spacing.lg,
      paddingRight: token.spacing["2xl"],
      gap: token.spacing.lg,
      border: `solid 4px ${token.color.gold}`,
      [`@container (max-width: ${MEDIUM}px)`]: {
        paddingRight: token.spacing.lg
      }
    }
  }).build();
};
const createCompositeAlertPage = (props) => new ElementBuilder().withClassName("alert-page-declaration").withChild(createContainer(props)).withStyles({
  element: {
    containerType: "inline-size"
  }
}).build();
export {
  createCompositeAlertPage
};
//# sourceMappingURL=page.js.map
